module.exports = __webpack_public_path__ + "src/images/products/allAmerican/70_Max Used Black Jeans.png";